var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.contextName,attrs:{"id":"app"}},[_c('app-header'),_c('div',{staticClass:"content-all"},[_c('router-view')],1),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }